<body style="overflow: hidden;">
  <app-nav-menu></app-nav-menu>
  <div class="container" style="overflow: hidden;;height:calc( 100% );position:fixed;top:0">
    <router-outlet></router-outlet>
  </div>
</body>
